import { Modal } from "antd";
import { ReactNode } from "react";

interface ModalButtonProps {
    className?: string;
    disabled?: boolean;
}

interface ConfirmModalProps {
    title?: ReactNode;
    content?: ReactNode;
    icon?: ReactNode | null;
    onConfirm: () => void;
    onCancel?: () => void;
    confirmText?: string;
    cancelText?: string;
    cancelButtonProps?: ModalButtonProps;
    confirmButtonProps?: ModalButtonProps;
    className: string;
    centered?: boolean;
    zIndex?: number;
}

export const showConfirmModal = ({
    title,
    content,
    icon = null,
    onConfirm = () => {},
    onCancel = () => {},
    confirmText = "",
    cancelText = "",
    cancelButtonProps,
    confirmButtonProps,
    className,
    centered,
    zIndex,
}: ConfirmModalProps) => {
    return Modal.confirm({
        title,
        content,
        icon,
        onOk: onConfirm,
        onCancel,
        okText: confirmText,
        cancelText,
        cancelButtonProps,
        okButtonProps: confirmButtonProps,
        className,
        centered,
        zIndex,
    });
};
